import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Paper, Grow, ClickAwayListener, Popper, Typography } from '@mui/material';

const PopperComponent = ({ open, anchorEl, id, handleClose, content }) => (
  <Popper
    id={id}
    placement='bottom-start'
    anchorEl={anchorEl}
    open={open}
    modifiers={{
      flip: {
        enabled: true
      },
      preventOverflow: {
        enabled: true,
        boundariesElement: 'scrollParent'
      }
    }}
  >
    <ClickAwayListener onClickAway={handleClose}>
      <Grow in={open}>
        <Paper>
          <Typography>{content}</Typography>
        </Paper>
      </Grow>
    </ClickAwayListener>
  </Popper>
);

PopperComponent.propTypes = {
  t: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.object,
  handleClose: PropTypes.func.isRequired,
  id: PropTypes.string,
  content: PropTypes.string
};

export default compose(withTranslation())(PopperComponent);
